export default __webpack_public_path__ + "static/media/active_checkbox.90dae782.svg";